
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {SymbolProfitLossMultipleInfoUnsubscribeResponse} from './SymbolProfitLossMultipleInfoUnsubscribeResponse';

/**
 * SymbolProfitLossMultipleInfoUnsubscribeRequest struct
 */
class SymbolProfitLossMultipleInfoUnsubscribeRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Set=} symbols
   * @constructor
   */
  constructor (parent = new Request(), symbols = new Set()) {
    super()
    super.copy(parent)
    this.Symbols = symbols
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeRequest} other Other struct
   * @returns {!SymbolProfitLossMultipleInfoUnsubscribeRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Symbols != null) {
      this.Symbols = new Set()
      for (let item of other.Symbols) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.Symbols.add(tempItem)
        } else {
          this.Symbols.add(null)
        }
      }
    } else {
      this.Symbols = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @returns {!SymbolProfitLossMultipleInfoUnsubscribeRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SymbolProfitLossMultipleInfoUnsubscribeRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SymbolProfitLossMultipleInfoUnsubscribeRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SymbolProfitLossMultipleInfoUnsubscribeRequest)) {
      throw new TypeError('Instance of SymbolProfitLossMultipleInfoUnsubscribeRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Symbols: ((this.Symbols != null) ? Array.from(this.Symbols, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SymbolProfitLossMultipleInfoUnsubscribeRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeRequest} other Object value
   * @returns {!SymbolProfitLossMultipleInfoUnsubscribeRequest} Created struct
   */
  static fromObject (other) {
    return new SymbolProfitLossMultipleInfoUnsubscribeRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SymbolProfitLossMultipleInfoUnsubscribeRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5222
  }
}

export { SymbolProfitLossMultipleInfoUnsubscribeRequest };

/**
 * Fast Binary Encoding SymbolProfitLossMultipleInfoUnsubscribeRequest field model
 */
class FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.Symbols = new fbe.FieldModelSet(new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Symbols.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Symbols.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5222
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Symbols.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Symbols.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbols.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeRequest} fbeValue Default value, defaults is new SymbolProfitLossMultipleInfoUnsubscribeRequest()
   * @returns {!SymbolProfitLossMultipleInfoUnsubscribeRequest} SymbolProfitLossMultipleInfoUnsubscribeRequest value
   */
  get (fbeValue = new SymbolProfitLossMultipleInfoUnsubscribeRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeRequest} fbeValue SymbolProfitLossMultipleInfoUnsubscribeRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Symbols.fbeSize) <= fbeStructSize) {
      this.Symbols.get(fbeValue.Symbols)
    } else {
      fbeValue.Symbols.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbols.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeRequest} fbeValue SymbolProfitLossMultipleInfoUnsubscribeRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest}
   * @param {SymbolProfitLossMultipleInfoUnsubscribeRequest} fbeValue SymbolProfitLossMultipleInfoUnsubscribeRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Symbols.set(fbeValue.Symbols)
  }
}

export { FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest };

/**
 * Fast Binary Encoding SymbolProfitLossMultipleInfoUnsubscribeRequest model
 */
class SymbolProfitLossMultipleInfoUnsubscribeRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest(this.buffer, 4)
  }

  /**
   * Get the SymbolProfitLossMultipleInfoUnsubscribeRequest model
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequestModel}
   * @returns {!FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest} model SymbolProfitLossMultipleInfoUnsubscribeRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SymbolProfitLossMultipleInfoUnsubscribeRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSymbolProfitLossMultipleInfoUnsubscribeRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequestModel}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeRequest} value SymbolProfitLossMultipleInfoUnsubscribeRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequestModel}
   * @param {!SymbolProfitLossMultipleInfoUnsubscribeRequest} value SymbolProfitLossMultipleInfoUnsubscribeRequest value, defaults is new SymbolProfitLossMultipleInfoUnsubscribeRequest()
   * @return {!object} Deserialized SymbolProfitLossMultipleInfoUnsubscribeRequest value and its size
   */
  deserialize (value = new SymbolProfitLossMultipleInfoUnsubscribeRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SymbolProfitLossMultipleInfoUnsubscribeRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SymbolProfitLossMultipleInfoUnsubscribeRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SymbolProfitLossMultipleInfoUnsubscribeRequestModel}
   * @param {!number} prev Previous SymbolProfitLossMultipleInfoUnsubscribeRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SymbolProfitLossMultipleInfoUnsubscribeRequestModel };
SymbolProfitLossMultipleInfoUnsubscribeRequest.__has_response = true;
SymbolProfitLossMultipleInfoUnsubscribeRequest.__response_class = SymbolProfitLossMultipleInfoUnsubscribeResponse;
